// extracted by mini-css-extract-plugin
export default {"calendarWrapper":"overviewCalendar_calendarWrapper__xEgTf","calendarBottom":"overviewCalendar_calendarBottom__FrLP7"};